import { MenuItem, Select, useTheme } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ComponentProps, FC } from 'react';
import { useApiQuery } from '../query/hooks';
import { graphql } from '../gql';
import { Typography } from '@mui/material';

const formJourneySelect_listJourney = graphql(`
	query formJourneySelect_listJourney {
		listJourney(filter: { isTemplate: { eq: false } }) {
			id
			name
		}
	}
`);

type JourneySelectProps = ComponentProps<typeof Select<string>> &
	Readonly<{
		loading?: boolean;
		hideAdd?: boolean;
	}>;

export const JourneySelect: FC<JourneySelectProps> = ({ value, onChange }) => {
	const { data, isLoading } = useApiQuery(formJourneySelect_listJourney);
	const theme = useTheme();

	if (isLoading) {
		return (
			<Typography sx={{ color: theme.palette.secondary.main }}>
				<FormattedMessage id={'common.loading'} />
			</Typography>
		);
	}

	return (
		<Select value={value} onChange={onChange}>
			<MenuItem value={''}>
				<FormattedMessage id={'common.dash'} />
			</MenuItem>

			{data?.listJourney.map((journey) => (
				<MenuItem key={journey.id} value={journey.id}>
					{journey.name}
				</MenuItem>
			))}
		</Select>
	);
};
